import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { Controller } from "react-hook-form";
import FormControl from "@material-ui/core/FormControl";



export const DateMonthPicker = ({
    name,
    label,
    control,
    defaultValue,
    placeholder,
    children,
    errors,
    rules,
    ...props
}) => {
    return (
        <>
            <div className="flex flex-col gap-2 ">
                <FormControl>
                    <Controller
                        name={name}
                        control={control}
                        rules={rules}
                        defaultValue={defaultValue}
                        render={({ field }) => {
                            return (
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker views={['month', 'year']}
                                        onChange={(newValue) => {
                                            field.onChange(newValue);
                                        }}
                                        maxDate={new Date()}
                                        value={field.value || ""}
                                        renderInput={(params) => {
                                             return (
                                             <TextField
                                             {...params}
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        padding: '0.75rem',
                                                    },
                                                    borderRadius: 2
                                                }}
                                            />
                                            ) }}
                                        yearsPerRow={3} />
                                 </LocalizationProvider>
                            )
                        }}
                    />
                </FormControl>
            </div>

        </>
    );
}